import { getListGameFreespin } from '../api/getListGameFreespin';
import {setGetListGameFreespinAction} from '../action';

const setGetListGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListGameFreespin(params);

            if (data.status === 'success') {
                dispatch(setGetListGameFreespinAction({
                    data: data.data,
                }));
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListGameFreespin
}